'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonOutline = undefined;

var _systemComponents = require('system-components');

var _systemComponents2 = _interopRequireDefault(_systemComponents);

var _styledSystem = require('styled-system');

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonOutline = exports.ButtonOutline = (0, _systemComponents2.default)({
  is: _Button2.default,
  color: 'blue',
  bg: 'transparent',
  hover: {
    color: 'white',
    backgroundColor: 'blue'
  }
}, function (props) {
  return {
    boxShadow: 'inset 0 0 0 2px ' + (0, _styledSystem.themeGet)('colors.' + props.color, props.color)(props)
  };
});

ButtonOutline.displayName = 'ButtonOutline';

exports.default = ButtonOutline;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/ButtonOutline.js
// module id = 801
// module chunks = 35783957827783